import { Component, OnInit, AfterViewInit, NgZone } from '@angular/core';
import { OrderGroup, Order } from 'src/app/models/order.model';
import { DBService } from 'src/app/services/db.service';
import { STORAGE_PERSONAL_DATA } from 'src/environments/environment';
import { UtilService } from 'src/app/services/util.service';
import { Router } from '@angular/router';
import { OrderService } from 'src/app/services/order.service';
import { DeliveryArea } from 'src/app/models/delivery-area.model';
import { Events } from 'src/app/services/events.service';
import { FormControl, Validators } from '@angular/forms';
import { LoadingController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
//import firebase from 'firebase/app';
import * as firebase from 'firebase/app';
import { STORAGE_PHONE_CONFIRMATIONS, STORAGE_LAST_ORDER, ANALYTICS_EV_ORDER_START, ANALYTICS_EV_ORDER_SENT_SMS, ANALYTICS_EV_ORDER_NUMBER_ALREADY_CONFIRMED, ANALYTICS_EV_ORDER_SEND_SMS, ANALYTICS_EV_ORDER_RESEND_SMS, ANALYTICS_EV_ORDER_SEND_SMS_FAILED, ANALYTICS_EV_ORDER_SMS_CODE_CORRECT, ANALYTICS_EV_ORDER_SMS_CODE_INCORRECT, ANALYTICS_EV_ORDER_PAYPAL_PAY, ANALYTICS_EV_ORDER_PAYPAL_ERROR, ANALYTICS_EV_ORDER_PAYPAL_CANCEL, ANALYTICS_EV_ORDER_CONTINUE_UNVERIFIED, ANALYTICS_EV_ORDER_NOT_MIN_AMOUNT, ANALYTICS_EV_NO_ADDRESS_RECOGNIZED, ANALYTICS_EV_DATA_SUCCESSFULLY_ENTERED } from 'src/environments/constant';
import { PhoneService } from 'src/app/services/phone.service';
import { MailService } from 'src/app/services/mail.service';
import { formatDate } from '@angular/common';
import { OpeningTime } from 'src/app/models/opening-time.model';
import { CoronaService } from 'src/app/pages/shared/corona/corona.service';

declare let paypal: any;

enum State {
  DATA_SCREEN = 1,
  SMS_CODE_SCREEN,
  SUMMARY_SCREEN,
  PAY_SCREEN
}

@Component({
  selector: 'app-eat-outside',
  templateUrl: './eat-outside.page.html',
  styleUrls: ['./eat-outside.page.scss'],
})
export class EatOutsidePage implements OnInit, AfterViewInit {

  selectedLocationSlot = undefined;

  //for locals with more then one location...
  pickupPlace: string = "";

  deliveryDate: string
  deliveryTime: string

  state: State = State.DATA_SCREEN

  saveData: boolean = true

  addressFailed: boolean = false
  timeFailed: boolean = false

  confirmedPhoneNumbers: string[] = []

  private openSmsCodeScreenUiTS: number = -1

  re = /[^-,0-9]/gi;
  reDoubleComma = /[-,]{2,}/gi
  reLineStart = /^[-,]/gi;

  // *** required when fullname in options is required ***
  firstName: string = ''
  lastName: string = ''

  get State() {
    return State
  }

  constructor(public db: DBService, private events: Events, public util: UtilService, private router: Router, private ngZone: NgZone,
    private orderService: OrderService, private loadingCtrl: LoadingController, private authService: AuthService, private phoneService: PhoneService,
    private mailService: MailService, private coronaService: CoronaService) {

    this.events.unsubscribe('backButtonInPaypal')
    this.events.subscribe('backButtonInPaypal', () => {
      this.util.warn("EVENT ausgelöst: backButtonInPaypal")
      this.back()
    });

    if (!this.db.currentRestaurantKey) {
      this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
      return
    }
    
    let d: Date = new Date(this.util.roundTime5Minutes(this.now + (this.db.currentPreperationTime * 1000 * 60)))
    this.deliveryTime = formatDate(d, 'HH:mm', 'de-DE')
    this.deliveryDate = formatDate(d, 'yyyy-MM-dd', 'de-DE')
    this.setValidPickupPlace(d)
  }

  setDeliveryTimeSlot(time: string, value: string){
    this.deliveryTime = time
    this.db.basket.noteFromRestaurant = "Vielen Dank - Deine Abholzeit beträgt: " + value + " Uhr. Bitte bringe ein Korb, Tasche o.ä. mit."
  }

  get now(){
    if(this.db.currentRestaurant.options && this.db.currentRestaurant.options.defaultTime){
      /*
      let min: number = 0
      if(this.db.currentRestaurant.options.orderSlots && this.db.currentRestaurant.options.orderSlots.length > 0 ){
        for(let slot of this.db.currentRestaurant.options.orderSlots){
          if(slot && slot.minutesOfDay){        
            return 1619820000000 + (+slot.minutesOfDay * 60 * 1000)
          }
        }
      }
      */
      return this.db.currentRestaurant.options.defaultTime
    }
    return new Date().getTime();
  }

  setLocationSlot(location){
    this.selectedLocationSlot = location
  }
  
  ngOnInit() {
    if (!this.db.currentRestaurantKey) {
      this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
      return
    }

    if (this.db.getBasketPrice(this.util.enableBonuskarten) <= 0) {
      this.ngZone.run(() => this.router.navigate(['/basket']))
      return
    }

    let d: Date = new Date(this.util.roundTime5Minutes(this.now + (this.db.currentPreperationTime * 1000 * 60)))
    this.deliveryDate = formatDate(d, 'yyyy-MM-dd', 'de-DE')
    this.deliveryTime = formatDate(d, 'HH:mm', 'de-DE')
    this.setValidPickupPlace(d)

    this.db.addAnalytics(ANALYTICS_EV_ORDER_START)

    let pastConfirmedNumbers = localStorage.getItem(STORAGE_PHONE_CONFIRMATIONS)
    if (pastConfirmedNumbers)
      this.confirmedPhoneNumbers = JSON.parse(pastConfirmedNumbers)

      //load from corona form...
    let group = this.coronaService.currentGroup
    if(group && group.guests && group.guests.length > 0){
      if(group.guests[0].name && group.guests[0].name.length > 0) this.db.basket.name = group.guests[0].name
      if(group.guests[0].phone && group.guests[0].phone.length > 0) this.db.basket.phone = group.guests[0].phone
      if(group.guests[0].address && group.guests[0].address.length > 0) this.db.basket.address = group.guests[0].address
    }

    let key = localStorage.getItem(STORAGE_PERSONAL_DATA)
    if (key) {
      let personalData = JSON.parse(key)
      this.db.basket.name = personalData.name

      if(this.db.basket.name && this.db.basket.name.split(" ") && this.db.basket.name.split(" ").length == 2){
        this.firstName = this.db.basket.name.split(" ")[0]
        this.lastName = this.db.basket.name.split(" ")[1]
      }

      this.db.basket.address = personalData.address
      this.db.basket.phone = personalData.phone
      this.db.basket.mail = personalData.mail

      //Wenn es ein Service ist und (entweder Telefonnummer schon bekannt ODER ohne Validierung), springe direkt raus
      if (this.orderService.currentService && (this.phonenumberAlreadyConfirmed || !this.db.currentRestaurant.phoneValidation)) {
        this.orderService.currentService.phone = this.db.basket.phone
        this.orderService.currentService.paid = true
        this.orderService.currentService.getippt = true
        this.finalizeWithoutPayment(this.orderService.currentService)
        this.orderService.currentService = undefined
        return
      }

      //Telefonnummer sollte ja bereits von der letzten Bestellung verifiziert sein... Ausser das Lokal ändert die Richtlinien!! = daher nochmal die Abfrage
      // wenn letzte Bestellung <5h her ist, muss man keine persönliche Daten mehr eingeben
      let lastOrder = localStorage.getItem(STORAGE_LAST_ORDER)
      if (this.phonenumberAlreadyConfirmed && lastOrder && (new Date().getTime() < (JSON.parse(lastOrder) + (1000 * 60 * 60 * 5)))) {
        //Schaun, dass alle Felder ausgefüllt sind
        let fields: string[] = [this.db.basket.name, this.db.basket.phone]
        if (!this.db.basket.isNativeApp) fields = fields.concat([this.db.basket.mail])
        if (this.db.basket.mode == "delivery") fields = fields.concat([this.db.basket.address])
        if (!this.util.hasEmptyFields(fields)) {
          this.state = State.SUMMARY_SCREEN
        }
      }
    }
    this.setTip(0)
  }

  ngAfterViewInit(): void {
    this.initializeRecaptcha()

    let d: Date = new Date(this.util.roundTime5Minutes(this.now + (this.db.currentPreperationTime * 1000 * 60)))
    this.deliveryDate = formatDate(d, 'yyyy-MM-dd', 'de-DE')
    this.deliveryTime = formatDate(d, 'HH:mm', 'de-DE')
    
    this.setValidPickupPlace(d)
  }

  recaptchaVerifier
  initializeRecaptcha() {
    let _this = this
    this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
      'size': 'invisible',
      'callback': function (response) {
        // reCAPTCHA solved, allow signInWithPhoneNumber.  
        console.log("Captcha Solved for SMS Code")
      }
    });
    console.log(firebase, this.recaptchaVerifier)
  }

  get phonenumberAlreadyConfirmed() {
    return this.confirmedPhoneNumbers.includes(this.db.basket.phone)
  }

  back() {
    console.log(this.state)
    if (this.state == State.DATA_SCREEN) {
      this.ngZone.run(() => this.router.navigate(['/basket']))
    } else if (this.state == State.SMS_CODE_SCREEN) {
      this.state = State.DATA_SCREEN
    } else if (this.state == State.SUMMARY_SCREEN) {
      this.state = State.DATA_SCREEN
    } else if (this.state == State.PAY_SCREEN) {
      this.state = State.SUMMARY_SCREEN
    }
  }

  validatePhone(phone: string): boolean {
    let phonenumber = this.phoneService.getNumber(phone)
    if (phonenumber) {
      this.db.basket.phone = phonenumber.phone_number
      return true
    }

    return false
  }

  get plzInLocationSlot(){
    let results = []
    if(this.db.basket.mode!='delivery') return results

    if(this.db.currentRestaurant.options && this.db.currentRestaurant.options.locationSlots){
      let deliveryArea: DeliveryArea = this.checkAddress(this.db.basket.address, this.db.currentRestaurant.deliveryAreas)
      if(!deliveryArea) return results

      let plzs = deliveryArea.areaCodes.replace(" ","").split(",")

      for(let plz of plzs){
        if(plz in this.db.currentRestaurant.options.locationSlots){
          for(let location of this.db.currentRestaurant.options.locationSlots[plz]) {
            results.push(location)
          }
        }
      }
    }

    return results
  }

  validateMail(mail: string) {
    return mail && mail.includes("@") && mail.includes(".") && mail.length > 4
  }

  get preOrderActive(): boolean {
    return this.db.currentRestaurant.preOrder && this.db.basket.mode != "eat-here"
  }

  get weekday(): number {
    let date = new Date(this.deliveryDate+"T"+this.deliveryTime)
    return date.getDay()
  }

  validDateAndTime(orderGroup: OrderGroup): boolean {
    if (!this.preOrderActive) {
      return true
    }

    let orderDate: Date = new Date(this.deliveryDate+"T"+this.deliveryTime)

    //1. check: keine Vergangenheit
    if (new Date().getTime() > orderDate.getTime()) {
      this.util.presentToast("Das ausgewählte Datum befindet sich in der Vergangenheit.", 3500, "toast-warning")
      return false;
    }

    let maxPreorderMinutesBeforeStart: number = 2880 //= 48 hours Vorbestellungen möglich
    if (this.db.currentRestaurant.options && this.db.currentRestaurant.options.maxPreorderMinutesBeforeStart) maxPreorderMinutesBeforeStart = this.db.currentRestaurant.options.maxPreorderMinutesBeforeStart

    //2. check: max 2 Tage im Vorraus (bzw. individuell durch options)
    if (new Date().getTime() + (1000 * 60 * maxPreorderMinutesBeforeStart) < orderDate.getTime()) {
      this.util.presentToast("Der ausgewählte Zeitpunkt befindet sich zu weit in der Zukunft.", 3500, "toast-warning")
      return false;
    }

    let openTime: OpeningTime
    for (openTime of this.db.currentRestaurant.oeffnungszeiten) {
      //*** Check if selected weekday is also found in opening times ***
      if (OpeningTime.getWeekdayNo(openTime.weekday) == orderDate.getDay()) {
        let startTime: Date = OpeningTime.getStringTimeAsDate(openTime.startTime)
        let endTime: Date = OpeningTime.getStringTimeAsDate(openTime.endTime)

        let startTimeInMinutesOfDay: number = startTime.getHours() * 60 + startTime.getMinutes()
        let endTimeInMinutesOfDay: number = endTime.getHours() * 60 + endTime.getMinutes()
        let selectedTimeInMinutesOfDay: number = orderDate.getHours() * 60 + orderDate.getMinutes()

        // *** Check if selected time is in opening time ***
        if (startTimeInMinutesOfDay <= selectedTimeInMinutesOfDay && (endTimeInMinutesOfDay >= selectedTimeInMinutesOfDay || endTimeInMinutesOfDay < startTimeInMinutesOfDay)) { //Letze Clause: If 02 Nachts ist dicht....

          // *** Checks, if enough time is available until opening time (e.g. last preorder only possible a day before) ***
          if (this.db.currentRestaurant.minPreorderMinutesBeforeStart > 0) {
            let startDate: Date = new Date(orderDate.getTime())
            startDate.setHours(startTime.getHours());
            startDate.setMinutes(startTime.getMinutes());
            let millisUntilStartOfOrderDay = startDate.getTime() - new Date().getTime()
            if (millisUntilStartOfOrderDay < this.db.currentRestaurant.minPreorderMinutesBeforeStart * 60 * 1000) {
              this.util.presentToast("Leider können wir für diesen Zeitraum keine Vorbestellungen mehr annehmen.", 4500, "toast-warning")
              return false;
            }
          }

          // *** Checks, if enough time is available for preperation (e.g. opens at 5pm, 1st food ready at 5.10pm), otherwise adapt delivery time for preperation ***
          if (startTimeInMinutesOfDay + this.db.currentPreperationTime > selectedTimeInMinutesOfDay) {
            this.util.presentToast("Deine Zeit wurde um ein paar Minuten angepasst, sodass wir deine Bestellung noch bearbeiten können.", 3500)
            let minutesToAdd: number = startTimeInMinutesOfDay + this.db.currentPreperationTime - selectedTimeInMinutesOfDay
            orderDate = new Date(orderDate.getTime() + minutesToAdd * 1000 * 60)
            this.deliveryDate = formatDate(orderDate, 'yyyy-MM-dd', 'de-DE')
            this.deliveryTime = formatDate(orderDate, 'HH:mm', 'de-DE')
          }

          // *** Block e.g. 18:00 Uhr (from 17:50 to 18:59, set to 19) ***
          if(this.db.currentRestaurant.options && this.db.currentRestaurant.options.blockPreOrderTime){
            if(selectedTimeInMinutesOfDay > this.db.currentRestaurant.options.blockPreOrderTime.fromInMinutesOfDay && selectedTimeInMinutesOfDay < this.db.currentRestaurant.options.blockPreOrderTime.untilInMinutesOfDay){
              this.util.presentToast("Aufgrund der hohen Nachfrage, wurde deine Abholzeit auf "+this.db.currentRestaurant.options.blockPreOrderTime.newHours+":"+this.db.currentRestaurant.options.blockPreOrderTime.newMinutes+" Uhr angepasst.", 4500)
              orderDate.setHours(this.db.currentRestaurant.options.blockPreOrderTime.newHours)
              orderDate.setMinutes(this.db.currentRestaurant.options.blockPreOrderTime.newMinutes)
              this.deliveryDate = formatDate(orderDate, 'yyyy-MM-dd', 'de-DE')
              this.deliveryTime = formatDate(orderDate, 'HH:mm', 'de-DE')
            }
          }

          //*** set value to order ***
          let millisUntilOrder = orderDate.getTime() - new Date().getTime()
          orderGroup.requiredTimeInMinutes = Math.round(millisUntilOrder / 1000 / 60)

          return true
        }

      }
    }

    this.util.presentToast("Der gewünschte Zeitpunkt liegt außerhalb der Öffnungszeiten.", 3500, "toast-warning")

    return false;
  }

  sameDay(d1: Date, d2: Date): boolean {
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
  }

  public async nextScreen() {
    this.addressFailed = false
    this.timeFailed = false

    if (this.db.getBasketPrice(this.util.enableBonuskarten) <= 0) {
      this.ngZone.run(() => this.router.navigate(['/basket']))
      return
    }

    if (!this.validDateAndTime(this.db.basket)) {
      this.timeFailed = true
      return
    }

    let minOrderValueChecked: boolean = false
    if (this.state == State.DATA_SCREEN) {
      if(this.db.currentRestaurant.options && this.db.currentRestaurant.options.locationSlots && this.plzInLocationSlot && this.plzInLocationSlot.length > 0 && this.db.basket.mode=='delivery'){
        if(!this.selectedLocationSlot) {
          this.util.presentToast("Bitte spezifiziere die Ortschaft.", 6000, "toast-warning")          
          return
        }else if(!this.selectedLocationSlot.active){
          this.util.presentToast("Es tut uns leid, leider können wir nicht nach "+this.selectedLocationSlot.city+" liefern.", 5000, "toast-warning")   
          return
        }else if(this.selectedLocationSlot.active && this.selectedLocationSlot.minOrderValue && parseFloat(this.selectedLocationSlot.minOrderValue.replace(",", ".")) > this.db.getBasketPrice(this.util.enableBonuskarten)){
          this.util.presentToast("Es tut uns leid, der Mindestbestellwert für "+this.selectedLocationSlot.city+" liegt bei "+this.selectedLocationSlot.minOrderValue+"€.", 5000, "toast-warning")   
          return;
        }

        if(this.selectedLocationSlot.active && this.selectedLocationSlot.minOrderValue) minOrderValueChecked = true
      }

      let fields: string[] = [this.db.basket.phone]

      if (this.db.currentRestaurant.options && this.db.currentRestaurant.options.fullnameRequired == true) fields = fields.concat([this.firstName, this.lastName])
      else fields = fields.concat([this.db.basket.name])

      if (!this.db.basket.isNativeApp) fields = fields.concat([this.db.basket.mail])
      if (this.db.basket.mode == "delivery") fields = fields.concat([this.db.basket.address])

      if (!this.db.basket.isNativeApp && !this.validateMail(this.db.basket.mail)) {
        this.util.presentToast("Bitte nutze eine korrekte Mail Adresse für Updates zu deiner Bestellung.", 3000, "toast-warning")
        return
      } else if (!this.validatePhone(this.db.basket.phone) && this.db.currentRestaurant.phoneValidation) {
        this.util.presentToast("Wir konnten deine Telefonnummer nicht verifizieren. Versuche es im Format +49123456789", 3000, "toast-warning")
        return
      } else if (this.util.hasEmptyFields(fields)) {
        this.util.presentToast("Bitte fülle alle Felder aus.", 3000, "toast-warning")
        return
      } else {
        if (this.saveData) this.saveSettings()

        if (this.db.basket.mode == "delivery") {
          let deliveryArea: DeliveryArea = this.checkAddress(this.db.basket.address, this.db.currentRestaurant.deliveryAreas)
          console.log("delvieryArea", deliveryArea)
          if (!deliveryArea) {
            this.db.addAnalytics(ANALYTICS_EV_NO_ADDRESS_RECOGNIZED, { address: this.db.basket.address })
            this.util.presentToast("Entschuldigung - Entweder wurde deine PLZ nicht erkannt oder deine Adresse liegt leider außerhalb des Liefergebietes", 3000, "toast-warning")
            this.addressFailed = true
            return
          }

          if (!minOrderValueChecked && parseFloat(deliveryArea.minAmount.replace(",", ".")) > this.db.getBasketPrice(this.util.enableBonuskarten)) {
            this.db.addAnalytics(ANALYTICS_EV_ORDER_NOT_MIN_AMOUNT, { price: this.db.getBasketPrice(this.util.enableBonuskarten), minAmount: deliveryArea.minAmount, address: this.db.basket.address })
            this.util.presentToast("Der Mindestbestellwert für deine PLZ liegt bei " + deliveryArea.minAmount + "€.", 4000, "toast-warning")
            return
          }
        }

        this.sendSMS()

        this.db.addAnalytics(ANALYTICS_EV_DATA_SUCCESSFULLY_ENTERED, {name: this.db.basket.name})   

        return
      }



    } else if (this.state == State.SUMMARY_SCREEN) {
      if (!this.db.currentRestaurant.paypal) {
        this.finalizeWithoutPayment(this.db.basket)
      } else {
        this.state = State.PAY_SCREEN
        this.paypal()
      }




    } else if (this.state == State.PAY_SCREEN) {
      this.back()
    }
  }

  verificationError: boolean = false

  async sendSMS() {
    if (this.db.currentRestaurant.options && this.db.currentRestaurant.options.fullnameRequired == true) {
      this.db.basket.name = this.firstName + " " + this.lastName
      if (this.saveData) this.saveSettings()
    }

    this.verificationError = false

    if (this.db.currentRestaurant.phoneValidation && !this.phonenumberAlreadyConfirmed) {
      this.db.addAnalytics(ANALYTICS_EV_ORDER_SEND_SMS)
      let _this = this
      const loading = await this.loadingCtrl.create({
        message: 'Telefonnummer wird verifiziert...',
        duration: 10000
      });
      loading.present()


      if (this.util.isIOS() && (this.util.platform.is('cordova') || this.util.platform.is('capacitor'))) {
        this.authService.requestSMSCodeIOS(this.db.basket.phone).then((verificationID) => {
          _this.authService.verificationID = verificationID
          _this.ngZone.run(() => {
            _this.state = State.SMS_CODE_SCREEN
            _this.openSmsCodeScreenUiTS = new Date().getTime()
            _this.db.addAnalytics(ANALYTICS_EV_ORDER_SENT_SMS)
            console.log('force update the screen');
          });
          _this.loadingCtrl.dismiss()
        }).catch((error) => {
          _this.loadingCtrl.dismiss()
          console.error("Custom Error", error)
          _this.db.addAnalytics(ANALYTICS_EV_ORDER_SEND_SMS_FAILED, { error: JSON.stringify(error) })
          //_this.util.presentToast("Fehler: " + JSON.stringify(error), 4500, "toast-warning") // Error; SMS not sent
          this.verificationError = true
          this.state = State.SUMMARY_SCREEN
        });
      } else {
        this.authService.requestSMSCodeWeb(this.db.basket.phone, this.recaptchaVerifier).then((confirmationResult) => {
          _this.authService.confirmationResult = confirmationResult
          _this.ngZone.run(() => {
            _this.state = State.SMS_CODE_SCREEN
            _this.db.addAnalytics(ANALYTICS_EV_ORDER_SENT_SMS)
            this.openSmsCodeScreenUiTS = new Date().getTime()
            console.log('force update the screen');
          });
          _this.loadingCtrl.dismiss()
        }).catch((error) => {
          _this.loadingCtrl.dismiss()
          _this.db.addAnalytics(ANALYTICS_EV_ORDER_SEND_SMS_FAILED, { error: JSON.stringify(error) })
          //_this.util.presentToast("Fehler: " + error.message, 4500, "toast-warning") // Error; SMS not sent
          this.verificationError = true
          this.state = State.SUMMARY_SCREEN
        });
      }

    } else {
      this.state = State.SUMMARY_SCREEN
      this.db.addAnalytics(ANALYTICS_EV_ORDER_NUMBER_ALREADY_CONFIRMED)
    }
  }

  continueUnverified() {
    if (this.openSmsCodeScreenUiTS + (1000 * 20) > new Date().getTime()) {
      this.util.presentToast("Bitte warte noch " + (20 - Math.round((new Date().getTime() - this.openSmsCodeScreenUiTS) / 1000)) + " Sekunden bevor du als 'nicht verifiziert' fortfahren möchtest. Eventuell ist die SMS bereits unterwegs zu dir.", 6000, "toast-warning")
      return
    }

    this.state = State.SUMMARY_SCREEN
    this.openSmsCodeScreenUiTS = new Date().getTime()
    this.db.addAnalytics(ANALYTICS_EV_ORDER_CONTINUE_UNVERIFIED)
    this.verificationError = true
  }

  resendSmsCode() {
    if (this.openSmsCodeScreenUiTS + (1000 * 30) > new Date().getTime()) {
      this.util.presentToast("Bitte warte mindestens 30s bevor du einen neuen Code anforderst. Eventuell ist die SMS bereits unterwegs zu dir.", 6000, "toast-warning")
      return
    }
    this.db.addAnalytics(ANALYTICS_EV_ORDER_RESEND_SMS)
    this.openSmsCodeScreenUiTS = new Date().getTime()
    this.sendSMS()
    this.util.presentToast("Ein neuer SMS Code wird gleich verschickt.")
  }

  smsCode = ""
  public checkSmsCode(smsCode: string) {
    smsCode += ""
    smsCode = smsCode.replace(" ", "");
    if (!smsCode || smsCode.length != 6) {
      this.util.presentToast("Der eingegebene Code muss 6 Ziffern lang sein", 5000, "toast-warning")
      return
    }

    let _this = this

    if (this.util.isIOS() && (this.util.platform.is('cordova') || this.util.platform.is('capacitor'))) {
      this.authService.loginViaSMSCodeIOS(smsCode).then(function (result) {
        _this.smsCodeWasCorrect()
      }).catch(function (error) {
        console.log(error)
        _this.db.addAnalytics(ANALYTICS_EV_ORDER_SMS_CODE_INCORRECT, { error: JSON.stringify(error) })
        _this.util.presentToast("Der eingegebene Code konnte nicht verifiziert werden", 4000, "toast-warning")
      });
    } else {
      this.authService.confirmationResult.confirm(smsCode).then(function (result) {
        _this.smsCodeWasCorrect()
      }).catch(function (error) {
        console.log(error)
        _this.db.addAnalytics(ANALYTICS_EV_ORDER_SMS_CODE_INCORRECT, { error: JSON.stringify(error) })
        _this.util.presentToast("Der eingegebene Code konnte nicht verifiziert werden", 4000, "toast-warning")
      });
    }
  }

  private smsCodeWasCorrect() {
    this.db.addAnalytics(ANALYTICS_EV_ORDER_SMS_CODE_CORRECT)
    this.util.presentToast("Der eingegebene Code ist korrekt")
    this.confirmedPhoneNumbers.push(this.db.basket.phone)
    localStorage.setItem(STORAGE_PHONE_CONFIRMATIONS, JSON.stringify(this.confirmedPhoneNumbers))

    //Code korrekt & Service: Jetzt bestellen
    if (this.orderService.currentService) {
      this.orderService.currentService.phone = this.db.basket.phone
      this.orderService.currentService.paid = true
      this.orderService.currentService.getippt = true
      this.finalizeWithoutPayment(this.orderService.currentService)
      this.orderService.currentService = undefined
      return
    }

    this.state = State.SUMMARY_SCREEN
  }



  finalizeWithoutPayment(orderGroup: OrderGroup) {
    if (this.db.getBasketPrice(this.util.enableBonuskarten, orderGroup) <= 0) {
      this.ngZone.run(() => this.router.navigate(['/basket']))
      return
    }

    if (this.verificationError) orderGroup.phone += " (nicht verifiziert)"

    this.finalizePotentialPreOrder(orderGroup)

    if (this.db.currentRestaurant.confirmOrderAutomatically) {
      if (orderGroup.mail && orderGroup.mail.length > 4) this.mailService.sendMailToCustomer("Neue Nachricht von " + this.db.currentRestaurant.name, "Deine Bestellung ist aufgenommen und bestätigt.", orderGroup.mail).subscribe((val: any) => { })

      orderGroup.confirmed = true
    }

    this.orderService.finallyOrder(orderGroup)
  }

  checkAddress(address: string, deliveryAreas: DeliveryArea[]) {
    let addressCodes: string = address.replace(this.re, ",").replace(this.reDoubleComma, ",").replace(this.reLineStart, "")
    if (!addressCodes || addressCodes.length <= 0) return undefined

    for (let adressCode of addressCodes.split(",")) {
      if (adressCode.length != 5) continue;
      for (let delvieryArea of deliveryAreas) {
        if (delvieryArea.areaCodes.includes(adressCode))
          return delvieryArea
      }
    }

    return undefined
  }

  setTip(tipInPercentage: number) {
    let tip = Math.round(this.db.getBasketPrice(this.util.enableBonuskarten) * tipInPercentage) * 100 / 100 / 100
    this.db.basket.tip = tip;
  }

  saveSettings() {
    localStorage.setItem(STORAGE_PERSONAL_DATA, JSON.stringify({
      name: this.db.basket.name,
      address: this.db.basket.address,
      phone: this.db.basket.phone,
      mail: this.db.basket.mail
    }))
  }

  async paypal() {
    if (this.db.getBasketPrice(this.util.enableBonuskarten) <= 0) {
      this.ngZone.run(() => this.router.navigate(['/basket']))
      return
    }

    const loading = await this.loadingCtrl.create({
      message: 'Zahlung wird abgeschlossen...',
      duration: 10000
    });

    const myNode = document.getElementById("paypal-button-container");
    myNode.innerHTML = '';

    let _this = this
    //https://developer.paypal.com/docs/checkout/reference/upgrade-integration/#5-finalize-the-payment
    paypal.Buttons({
      style: {
        layout: 'vertical',
        color: 'blue',
        shape: 'rect',
        label: 'paypal'
      },
      createOrder: function (data, actions) {
        // This function sets up the details of the transaction, including the amount and line item details.
        return actions.order.create({
          purchase_units: _this.createPurchaseUnits()
        });
      },

      onApprove: function (data, actions) {
        console.log("onApprove", data, actions)

        _this.db.addAnalytics(ANALYTICS_EV_ORDER_PAYPAL_PAY)

        loading.present();

        if (_this.verificationError) _this.db.basket.phone += " (nicht verifiziert)"

        _this.events.subscribe('orderSent', (updatedOrderGroup: any) => {
          // This function captures the funds from the transaction.

          return actions.order.capture().then(function (details) {
            // This function shows a transaction success message to your buyer.
            console.log("capture details", details)

            _this.events.unsubscribe('orderSent')
            _this.util.popup('green', '', 'thxForYourOrder')
            _this.db.setPage('home')
            // this.ngZone.run(() => this.router.navigate(['/customer-home']))  //Doch nicht zur Hauptseite zurueckkehren
            _this.ngZone.run(() => _this.router.navigate(['/order']))
            _this.loadingCtrl.dismiss()
            loading.dismiss()

            updatedOrderGroup.orderGroup.paid = true
            _this.mailService.sendMail(updatedOrderGroup.orderGroup, _this.db.currentRestaurant.mail).subscribe(val => { console.log(val) })
            _this.mailService.sendOrderConfirmation(updatedOrderGroup.orderGroup, updatedOrderGroup.orderGroup.mail, _this.db.currentRestaurant.name).subscribe(val => { console.log(val) })
            _this.db.updateOrderGroup(updatedOrderGroup.orderGroup)
          }, err => {
            console.log("capture error", err)
            _this.db.setPage('home')
            loading.dismiss()
            _this.loadingCtrl.dismiss()
            _this.util.presentToast("Vielen Dank für deine Bestellung. Leider ist bei der Paypal Bezahlung ein Fehler aufgetreten. Die Bestellung wurde aber abgeschickt. Bitte zahle alternativ bar oder mit EC Karte. Vielen Dank.", 12000, "toast-warning")
            _this.db.addAnalytics(ANALYTICS_EV_ORDER_PAYPAL_ERROR, { error1: JSON.stringify(err) })
            _this.ngZone.run(() => _this.router.navigate(['/order']))
          });
        })

        _this.finalizePotentialPreOrder(_this.db.basket)
        if (_this.db.currentRestaurant.confirmOrderAutomatically) {
          if (_this.db.basket.mail && _this.db.basket.mail.length > 4) _this.mailService.sendMailToCustomer("Neue Nachricht von " + _this.db.currentRestaurant.name, "Deine Bestellung ist aufgenommen und bestätigt.", _this.db.basket.mail).subscribe((val: any) => { })
          _this.db.basket.confirmed = true
        }

        _this.orderService.finallyOrder(_this.db.basket, true)  //Send first order....

      },
      onCancel: function (data, actions) {
        _this.util.presentToast("Die Zahlung wurde abgebrochen", 3000, "toast-warning")
        _this.db.addAnalytics(ANALYTICS_EV_ORDER_PAYPAL_CANCEL)
        console.log("onCancel", data, actions)
      },

      onError: function (err) {
        console.log("onError", err)
        _this.db.addAnalytics(ANALYTICS_EV_ORDER_PAYPAL_ERROR, { error2: JSON.stringify(err) })
        _this.util.presentToast("Entschuldigung - Es ist ein Fehler bei der Paypal Bezahlung aufgetreten. Die Bestellung wurde nicht abgeschickt. Bitte versuche es noch einmal oder bestelle alternativ per Telefon. Vielen Dank.", 20000, "toast-warning")
      }
    }).render('#paypal-button-container');
  }


  //Create units for paypal submit
  createPurchaseUnits(): any[] {
    this.totalPrice = 0
    let purchaseUnits: any[] = []
    for (let orderItem of this.db.basket.order) {
      let unit = this.createPurchaseUnit(orderItem)
      if (unit) purchaseUnits.push(unit)
    }

    //Trinkgeld
    if (this.db.basket.tip && this.db.basket.tip > 0) {
      this.totalPrice += this.db.basket.tip
      purchaseUnits.push(
        {
          unit_amount: {
            currency_code: 'EUR',
            value: this.util.formatPrice(this.db.basket.tip) + ''
          },
          quantity: "1",
          name: 'Trinkgeld'
        }
      )
    }

    let json = [{
      reference_id: this.util.uuidv4(),
      description: "BARELA - So einfach kann bestellen sein",
      payee: {
        email_address: this.db.currentRestaurant.paypal
      },
      amount: {
        currency_code: "EUR",
        value: this.util.formatPrice(this.totalPrice),
        breakdown: {
          item_total: {
            currency_code: "EUR",
            value: this.util.formatPrice(this.totalPrice)
          }
        }
      },
      items: purchaseUnits
    }]

    return json;
  }

  totalPrice: number = 0
  createPurchaseUnit(orderItem: Order) {
    let price: number = 0
    let amount = orderItem.amount

    let item = this.db.findItem(orderItem.itemKey)
    if (amount && item) {
      if (orderItem.bonuscardPrice !== -1 && this.util.enableBonuskarten) {
        price += (orderItem.bonuscardPrice)
      } else if (item.takeAwayPrice > -1 && this.db.basket.mode == "take-away") {
        price += (item.takeAwayPrice)
      } else if (item.isSpecialPriceActive) {
        price += (item.specialPrice)
      } else {
        price += (item.price)
      }

      if (orderItem.extraPrice) {
        price += (orderItem.extraPrice)
      }

      if (orderItem.optionPrice > 0) {
        price += (orderItem.optionPrice)
      }
    }

    if (+price <= 0) return undefined;
    this.totalPrice += (price * amount)

    return {
      unit_amount: {
        currency_code: 'EUR',
        value: this.util.formatPrice(price)
      },
      name: item.name,
      quantity: amount + ""
    }
  }

  finalizePotentialPreOrder(orderGroup: OrderGroup) {
    // add location in notes for locals with more then one location...
    if(this.db.currentRestaurant.options && this.db.currentRestaurant.options.locations){
      let selectedLocation = this.db.currentRestaurant.options.locations.find(location => location.value == this.pickupPlace);
      if(selectedLocation) {
        orderGroup.noteFromRestaurant = selectedLocation.description
        //Restaurant sagen, wo der Kunde es abholt.
        orderGroup.note = "Abholort: " + this.pickupPlace + " | " + orderGroup.note
      }
    }

    // add specific address city when city is selected (and options available)
    if(this.db.basket.mode=='delivery' && this.db.currentRestaurant.options && this.db.currentRestaurant.options.locationSlots 
        && this.plzInLocationSlot && this.plzInLocationSlot.length > 0 && this.selectedLocationSlot && this.selectedLocationSlot.city){
          orderGroup.address += " " + this.selectedLocationSlot.city
    }
  }

  // for locals with more locations, set location based on selected time and opening weekdays for each location
  setValidPickupPlace(selectedDate: Date){
    if (!this.db.currentRestaurant.options || !this.db.currentRestaurant.options.locations) return
    let weekday = selectedDate.getDay()

    //Check 1st current selection - if it is valid, stay with it...
    let selectedLocation = this.db.currentRestaurant.options.locations.find(location => location.value == this.pickupPlace);
    if(selectedLocation && selectedLocation.weekday.includes(weekday)) {
      return
    }

    for(let ix=0; ix<this.db.currentRestaurant.options.locations.length; ix++){
      if(this.db.currentRestaurant.options.locations[ix].weekday.includes(weekday)){
        this.pickupPlace = this.db.currentRestaurant.options.locations[ix].value;
        break;
      }
    }
  }

  // for locals with more locations, dropdown of location changed
  dateChanged(e) {
    if (e && e.detail && e.detail.value) {
      let date = new Date(e.detail.value)
      this.setValidPickupPlace(date)
    }
  }

}
